module.exports = __webpack_public_path__ + "img/1356974525.9dacc528.jpg";